
app.filter('addTargetBlank', function () {
  return function (x) {
    var tree = angular.element('<div>' + x + '</div>');
    tree.find('a').attr('target', '_blank'); 
    return angular.element('<div>').append(tree).html(); 
  };
});
